<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'信息漏斗'},{title:'月度抢单-非签约'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
            <div class="h-piece">
                <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                  <div class="h-thirdColumn w-newColumn">
                  <el-form-item class="h-elformWrap-1" label="客户名称">
                  <el-input v-model="q.username" placeholder="请输入客户姓名/编码" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="渠道" prop="chanel">
                    <el-select v-model="q.chanel" clearable placeholder="请选择" style="width:100%">
                      <el-option v-for="item in qudaoList"
                                 :key="item.code"
                                 :label="item.name"
                                 :value="item.code">
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="链群" prop="link">
                    <el-select v-model="q.link" clearable placeholder="请选择" style="width:100%">
                      <el-option v-for="item in linkList"
                                 :key="item.code"
                                 :label="item.name"
                                 :value="item.name">
                      </el-option>
                    </el-select>
                  </el-form-item>
                    <el-form-item label="年度">
                      <el-select filterable v-model="q.year" clearable placeholder="请选择">
                        <el-option
                            v-for="(item) in qyearList"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="h-thirdColumn w-newColumn">
                    <el-form-item  label="月度" class="h-elformWrap-2" prop="username">
                      <el-select filterable v-model="q.month" clearable placeholder="请选择"
                      >
                        <el-option
                            v-for="(item,index) in monthList"
                            :key="item"
                            :label="item"
                            :value="item">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="区域" prop="area">
                      <el-select v-model="q.area" clearable placeholder="请选择" style="width:100%">
                        <el-option v-for="item in quyuList"
                                   :key="item.code"
                                   :label="item.name"
                                   :value="item.name">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-form>

                <!-- 展开搜素 -->
                <div class="l-screenBox">
                    <div class="l-retrieval">
                    <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
                    <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                    <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createNew">
                        新建目标
                    </el-button>
                    </div>
                </div>
            </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <el-table
                    ref="multipleTable"
                     @selection-change="handleSelectionChange"
                    :data="tableData"
                    :border="true"
                    stripe
                    max-height="560"
                    style="width: 100%" >
                        <el-table-column
                        type="selection"
                        width="55"></el-table-column>
                        <el-table-column
                            label="序号"
                            type="index"
                            width="50">
                        </el-table-column>
                        <el-table-column prop="area" label="区域" width="80" ></el-table-column>
                        <el-table-column prop="usercode" label="客户编码" width="150" ></el-table-column>
                        <el-table-column prop="username" label="客户名称" width="180" ></el-table-column>
                      <el-table-column
                          prop="link"
                          label="链群"
                          width="100"
                          :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                          <dictname category="xsyb_lianqun" :v="scope.row.link"/>
                        </template>
                      </el-table-column>
                        <el-table-column
                                prop="chanel"
                                label="渠道"
                                width="100"
                                :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <dictname category="sales_region" :v="scope.row.chanel"/>
                            </template>
                        </el-table-column>
                        <el-table-column prop="year" label="年度" width="80" ></el-table-column>
                        <el-table-column prop="month" label="月度" width="80" ></el-table-column>
                        <el-table-column prop="lianqunMoney" label="链群抢单金额" width="100" :show-overflow-tooltip="true" ></el-table-column>
                        <el-table-column prop="loudouMoney" label="漏斗项目汇总金额" width="100" :show-overflow-tooltip="true" ></el-table-column>
                        <el-table-column prop="mubanMoney" label="抢单样板汇总金额" width="100" :show-overflow-tooltip="true" ></el-table-column>
                        <el-table-column prop="otherMoney" label="其他途径汇总金额" width="100" :show-overflow-tooltip="true" ></el-table-column>
                        <!-- <el-table-column prop="grabBill" label="抢单(万)" width="100" ></el-table-column>

                        <el-table-column prop="loudItems" label="项目名称" width="100" ></el-table-column>
                        <el-table-column prop="productCount" label="漏斗编号" width="100" ></el-table-column>
                        <el-table-column prop="productPrice" label="金额(万)" width="100" ></el-table-column>
                        <el-table-column prop="productTotalSales" label="总销额(万)" width="100" ></el-table-column>

                        <el-table-column prop="monthly" label="样板分类" width="100" ></el-table-column>
                        <el-table-column prop="oneWeek" label="用户单位" width="100" ></el-table-column>
                        <el-table-column prop="twoWeek" label="样板达成目标" width="100" ></el-table-column> -->
                        <!-- <el-table-column prop="threeWeek" label="第三周" width="100" ></el-table-column>
                        <el-table-column prop="fourWeek" label="第四周" width="100" ></el-table-column>
                        <el-table-column prop="orderType" label="订单类型" width="100" ></el-table-column>
                        <el-table-column prop="systemProductType" label="系统产品分类" width="100" ></el-table-column>
                        <el-table-column prop="productNumber" label="产品型号" width="100" ></el-table-column>
                        <el-table-column prop="chainGroup " label="链群" width="100" ></el-table-column>
                        <el-table-column prop="lineBody" label="线体" width="100" ></el-table-column> -->
                        <el-table-column prop="cuname" label="创建人" width="99" ></el-table-column>
                    <el-table-column prop="cdate" label="创建时间" :formatter="formatDate" width="117">
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        fixed="right"
                        width="150">
                        <template slot-scope="scope">
<!--                            <el-button-->
<!--                                type="text"-->
<!--                                size="small"-->
<!--                                class="h-tableLink h-btn"-->
<!--                                @click="searchDetail(scope.row)"-->
<!--                            >查看详情</el-button>-->
                            <el-button
                                    type="text"
                                    size="small"
                                    class="h-tableLink h-btn"
                                    @click="updateDetail(scope.row)"
                            >编辑</el-button>
                            <el-button
                            type="text"
                            size="small"
                            class="h-tableLink h-btn"
                            @click="deleteSingle(scope.row.id)"
                            >删除</el-button>

                        </template>
                    </el-table-column>
                </el-table>

            </div>
            <div class="h-tableB h-mrt30">
                <!--  -->
                <div class="h-tableBL">
                    <div class="h-tableBL">
                        <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除</el-button>
                        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                    </div>
                </div>
                <!-- 分页 -->
                <div class="h-pagination2">
                    <pagination :page="q" @query="selectPageAll" />
                </div>
            </div>
        </div>
        <!-- 弹出层 -->
        <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
          <div class="h-dialogImg">
              <div class="h-disTable">
                <div class="h-tableCell"  v-if="this.cWindow">
                  <h1>新建目标</h1>
                </div>
                <div class="h-tableCell"  v-if="this.pWindow">
                  <h1>编辑目标</h1>
                </div>
              </div>
          </div>
          <div class="h-formLines">
              <div style="padding: 12px;" class="dialogout X-dai">
                  <el-form :model="add" label-position="right" :inline="true" :rules="editFormRules" label-width="120"
                      class="demo-ruleForm h-formbLine h-formbLine1">
                    <div class="addPro">
                      <el-form-item label="客户名称" prop="username">
                          <el-select v-model="add.username"  remote filterable :filter-method="showFormList" clearable :disabled="isDsi" placeholder="请输入"
                                :remote-method="showFormList" @change="showFormList" >
                                    <el-option v-for="(item) in optionList"
                                                :key="item.userName"
                                                :label="item.userName"
                                                :value="item.userName">
                                    </el-option>
                                </el-select>
                      </el-form-item>
                      <el-form-item label="客户编码">
                          <el-input v-model="add.usercode" placeholder="自带出" disabled=""></el-input>
                      </el-form-item>
                      <el-form-item label="月度" prop="custMonth">
                        <el-date-picker type="month" placeholder="月度" v-model="add.custMonth"
                                        value-format="yyyy-MM" style="width: 100%;">
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item label="渠道"  prop='chanel' @change='getValue'>
                        <brselect category="sales_region" v-model="add.chanel" :v="add.chanel" :clearable="true" />
                      </el-form-item>
                      <div class="addPro">
<!--                        <el-button @click="addLink()" type="text" size="mini" style="float:right;font-size:20px;margin-right: -5px" icon="el-icon-circle-plus" circle></el-button>-->
                        <div v-for="(listIt, index) in add.links" :key="index">
<!--                          <el-button @click="deleteLink(index)" v-if="index != 0" type="text" style="float:right;font-size:20px;margin-right: -5px" size="mini" icon="el-icon-remove" circle></el-button>-->
                          <el-form-item label="链群	" prop="link">
                            <el-select v-model="add.links[index].link" @change='getValue'>
                              <el-option v-for="item in linkList"
                                         :key="item.code"
                                         :label="item.name"
                                         :value="item.code">
                              </el-option>
                            </el-select>
                          </el-form-item>
                          <el-form-item label="抢单(万元)" prop="grabBill ">
                            <el-input  oninput="value=value.replace(/[^\d.]/g,'')" v-model="add.links[index].grabBill" ></el-input>
                          </el-form-item>
                        </div>
                      </div>
<!--                      <el-form-item label="区域">-->
<!--                          <el-input v-model="add.area" placeholder="自带出" disabled=""></el-input>-->
<!--                      </el-form-item>-->
                    </div>
                  </el-form>
              </div>
          </div>
            <div style="display:flex;margin-left: 20px;margin-right: 20px;margin-bottom: 20px" class="card-namber">
                    <span :class="{buttonActive: switchNewTab ===1}" @click="switchNewCurve(1)" style="cursor:pointer">
                         <i class="iconfont iconshijian1"></i>
                         漏斗项目
                    </span>
                    <span :class="{buttonActive: switchNewTab ===2}" @click="switchNewCurve(2)" style="cursor:pointer">
                         <i class="iconfont iconzhexiantongji"></i>
                         抢单样板项目
                    </span>
                    <span :class="{buttonActive: switchNewTab ===3}" @click="switchNewCurve(3)" style="cursor:pointer">
                         <i class="iconfont iconzhexiantongji"></i>
                         其他途径信息
                    </span>
            </div>

          <el-form :model="add" label-position="right" :inline="true" :rules="editFormRules" label-width="120"
                   class="demo-ruleForm h-formbLine h-formbLine1">
            <el-button @click="addUser()" type="text" size="mini"  style="float:right;font-size:20px; margin-right:-5px " v-show="switchNewTab ==1" icon="el-icon-circle-plus" circle></el-button>
            <div v-for="(listIt, index) in add.loudItems" :key="index" class="addPro" v-show="switchNewTab == 1">
              <el-button style="font-size:20px;color:crimson;float:right; margin-right:-5px" @click="deleteUser(index)" v-if="index != 0" type="text" size="mini" icon="el-icon-remove" circle></el-button>
              <div>
              <el-form-item  label="用户单位">
                <el-select v-model="add.loudItems[index].projectname" filterable :filter-method="shouLoudou" clearable  placeholder="请输入"
                           :remote-method="shouLoudou" @change="changeLoudou($event,index)" >
                  <el-option v-for="(item) in loudouList"
                             :key="item.id"
                             :label="item.projectName+'-'+item.proModel"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="漏斗编号">
                <el-input v-model="add.loudItems[index].funnelCode" :title="add.loudItems[index].funnelCode" disabled=""></el-input>
              </el-form-item>
              <el-form-item  label="金额(万元)" >
                <el-input v-model="add.loudItems[index].brandPrice" oninput="value=value.replace(/[^\d.]/g,'')">
                </el-input>
              </el-form-item>
              </div>
            </div>
            <el-button @click="addTemplate()" type="text" size="mini"  style="float:right;font-size:20px; margin-right:-5px " v-show="switchNewTab ==2" icon="el-icon-circle-plus" circle></el-button>
            <div v-for="(listIt, index) in add.templateItems" :key="index"  class="addPro" v-show="switchNewTab == 2">
              <el-button style="font-size:20px;color:crimson;float:right; margin-right:-5px" @click="deleteTemplate(index)" v-if="index != 0" type="text" size="mini" icon="el-icon-remove" circle></el-button>
              <div>
              <el-form-item label="样板类型" prop="templateType">
                <el-select v-model="add.templateItems[index].templateType"   >
                  <el-option v-for="(item) in planList"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="样板达成目标" >
                <!-- <el-input  >
                </el-input> -->
                <el-select v-model="add.templateItems[index].templateReachTarget">
                  <el-option v-for="(item) in templateReachTargetList"
                             :key="item"
                             :label="item"
                             :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="金额(万元)" >
                <el-input v-model="add.templateItems[index].price" oninput="value=value.replace(/[^\d.]/g,'')">
                </el-input>
              </el-form-item>
                <el-form-item label="用户单位">
                  <el-select v-model="add.templateItems[index].customerCompany" :title="add.templateItems[index].customerCompany" remote filterable :filter-method="showFindByNameList" clearable  placeholder="请输入"
                             :remote-method="showFindByNameList" @change="showFindByNameList" >
                    <el-option v-for="(item) in findByNameList"
                               :key="item.userName"
                               :label="item.userName"
                               :value="item.userName">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <el-button @click="addOther()" type="text" size="mini"  style="float:right;font-size:20px; margin-right:-5px " v-show="switchNewTab ==3" icon="el-icon-circle-plus" circle></el-button>
            <div v-for="(listIt, index) in add.otherItems" :key="index"  class="addPro" v-show="switchNewTab == 3">
              <el-button style="font-size:20px;color:crimson;float:right; margin-right:-5px" @click="deleteOther(index)" v-if="index != 0" type="text" size="mini" icon="el-icon-remove" circle></el-button>
              <div>
              <el-form-item label="其他途径	" >
                <el-input v-model="add.otherItems[index].other">
                </el-input>
              </el-form-item>
              <el-form-item label="金额(万元)" >
                <el-input v-model="add.otherItems[index].money" oninput="value=value.replace(/[^\d.]/g,'')">
                </el-input>
              </el-form-item>
              </div>

            </div>

          </el-form>

          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button v-if="!this.add.id" class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
            <el-button v-if="this.add.id" class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()">修改</el-button>
          </div>
        </el-dialog>

        <!-- 查看详情 -->
        <el-dialog :close-on-click-modal="false" @close='exitColse' :visible.sync="detailedDialog" class="h-dialog2">
          <div class="h-dialogImg">
              <div class="h-disTable">
                  <div class="h-tableCell">
                      <h1>查看详情</h1>
                  </div>
              </div>
          </div>
          <div class="h-formLines">
              <div style="padding: 12px;" class="dialogout X-dai">

                <div  class="card-namber">
					<span :class="{buttonActive: switchBtnTab ===0}" @click="switchCurve(0)">
					   <i class="iconfont iconshijian1"></i>
					   漏斗项目
					</span>
					<span :class="{buttonActive: switchBtnTab ===1}" @click="switchCurve(1)">
					   <i class="iconfont iconzhexiantongji"></i>
					   抢单样板项目
					 </span>
                     <span :class="{buttonActive: switchBtnTab ===2}" @click="switchCurve(2)">
					   <i class="iconfont iconzhexiantongji"></i>
					   其他途径项目
					 </span>
                </div>
                <div class="main">
                    <div class="text item" v-show="switchBtnTab == 0">
                        <div class="loudItems-title">
                            <span>项目名称</span>
                            <span>漏斗编号</span>
                            <span>金额(万元)</span>
                        </div>
                        <div class="loudItems">
                            <div class="content" v-for="(item,index) in this.loudItems" :key="index">
                                <div class="" style="width:33%">{{item.projectname}}</div>
                                <div style="width:33%">{{item.funnelCode}}</div>
                                <div>{{item.totalPrice}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 第二个切换 -->
                    <div class="text item" v-show="switchBtnTab == 1">
                        <div class="templateItems-title">
                            <span>样板分类</span>
                            <span>样板达成目标</span>
                            <span>金额(万元)</span>
                            <span>用户单位	</span>
                        </div>
                        <div class="loudItems">
                            <div class="content" v-for="(item,index) in this.templateItems" :key="index">
                                <div class="" style="width:25%">{{item.templateType}}</div>
                                <div style="width:25%">{{item.templateReachTarget}}</div>
                                <div>{{item.price}}</div>
                                <div>{{item.customerCompany}}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 第三个切换 -->
                    <div class="text item" v-show="switchBtnTab == 2">
                        <div class="templateItems-title">
                            <span style="width:50%">其他途径</span>
                            <span>金额(万元)</span>
                        </div>
                        <div class="loudItems">
                            <div class="content" v-for="(item,index) in this.otherItems" :key="index">
                                <div class="" style="width:50%">{{item.other}}</div>
                                <div>{{item.money}}</div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div style="display:flex;justify-content:center;margin-bottom:20px">
                  <el-button class="h-btn h-bBtn h-bgblueQ2" @click="exitColse">关闭</el-button>
              </div>
          </div>
        </el-dialog>
    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
export default {
    data() {
        return {
            q:{
                usercode:"",
                username:"",
                link:'',
                pageNo:1,
                pageSize:10,
                total:0,
                type:2,
                year:"2022",
                month:"",
                dates:"",
                lianqunMoney:'',
                loudouMoney:'',
                mubanMoney:'',
            },
            tableData: [],
            //表格
            multipleSelection: [],
            findByNameList:[],
            quyuList: [],
            qyearList: [],
            qudaoList:[],
            linkList:[],
            monthList:["01","02","03","04","05","06","07","08","09","10","11","12"],
            // 展开折叠筛选
            isScreen:false,
            uploaddownexcelflag:false,
            newDialog:false,
            detailedDialog:false,
            cWindow:false,
            pWindow:false,
            isDsi:false,
            switchNewTab: 1,
            productCodeList:[],
            showFormProductList:[],
            optionList:[],
            loudItems:[],
            links:[],
            templateItems:[],
            otherItems:[],
            switchBtnTab: 0,    //默认选中第一个
			title: '选项1',
			titleArr: ['选项1','选项2','选项3'],
            add:{
                username:'',
                area:'',
                link:'',
                city:'',
                usercode:'',
                chanel:'',
                grabBill:'',
                month:'',
                custMonth:'',
                loudItems:[{
                    projectname:'',
                    funnelCode:'',
                    brandPrice:''
                }],
                templateItems:[{
                    templateType:'',
                    templateReachTarget:'',
                    price:'',
                    customerCompany:'',
                }],
                links:[{
                  link:'',
                  grabBill:'',
                }],
                otherItems:[{
                    other:'',
                    money:''
                }],
                year:'',
                type:2
            },
            planList:[],
            loudouList:[],
            rebateSeriesList:[],
            templateReachTargetList:[],
            editFormRules: {
                username: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                chanel: [{required: true, message: '请输入必填项', trigger: 'blur'}],
                product:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                custMonth:[{required: true, message: '请输入必填项', trigger: 'blur'}],
                grabBill:[{required: true, message: '请输入必填项', trigger: 'blur'}],
            },
        }
    },

    methods: {

        createNew(){
            this.isDsi = false;
            this.newDialog = true;
            this.cWindow = true;
            this.pWindow = false;
            this.loudItems = '';
        },
        addUser(){
            this.add.loudItems.push({projectname:'',funnelCode:'',brandPrice:''})
        },
        addLink(){
          this.add.links.push({link:'',grabBill:''})
        },
        deleteUser(index){
            console.log(index)
            this.add.loudItems.splice(index, 1)
        },
        //子模版项
        addTemplate(){
            this.add.templateItems.push({templateType:'',
                    templateReachTarget:'',
                    price:'',
                    customerCompany:'',})
        },
        deleteTemplate(index){
            console.log(index)
            this.add.templateItems.splice(index, 1)
        },
        deleteLink(index){
          console.log(index)
          this.add.links.splice(index, 1)
        },
        addOther(){
            this.add.otherItems.push({other:'',	money:'',})
        },
        deleteOther(index){
            console.log(index)
            this.add.otherItems.splice(index, 1)
        },
        commitUpdate(){
            this.add.month = this.add.custMonth
            var obj = this.add.month
            var index=obj.lastIndexOf("\-");
            obj=obj.substring(index+1,obj.length);
            var month = obj
            this.$set(this.add, "month", month);

            var data =this.add
            ss.netApi.editOrdersCustom(data).then(res => {
                console.log(res)
                if (res.f) {
                    this.$message({
                        type: "success",
                        message: res.msg
                    });
                    this.selectPageAll();
                    this.newDialog = false;
                    this.add={}
                } else {
                    this.$message({
                        type: "error",
                        message: response.msg
                    });
                }
            })
        },
        commitCreate(){
            this.add.month = this.add.custMonth
            var obj = this.add.month
            var str = this.add.month
            str = str.substring(0,4)
            var index=obj.lastIndexOf("\-");
            obj=obj.substring(index+1,obj.length);
            var month = obj
            this.$set(this.add, "month", month);
            this.$set(this.add, "year", str);
            var data =this.add
            ss.netApi.saveNoSignCustom(data).then(res => {
                console.log(res)
                if (res.f) {
                    this.$message({
                        type: "success",
                        message: res.msg
                    });
                    this.selectPageAll();
                    this.closeDialog()
                } else {
                    this.$message({
                        type: "error",
                        message: response.msg
                    });
                }
            })
        },
        searchDetail(row){
            console.log(row)
            this.detailedDialog = true;
            this.loudItems = row.loudItems
            this.templateItems = row.templateItems
            this.links = row.links
            this.otherItems = row.otherItems
        },
        //关闭弹框的事件
        closeDialog(){
            this.newDialog = false
            this.add={
                username:'',
                area:'',
                usercode:'',
                chanel:'',
                grabBill:'',
                month:'',
                loudItems:[{
                    projectname:'',
                    funnelCode:'',
                    brandPrice:''
                }],
                templateItems:[{
                    templateType:'',
                    templateReachTarget:'',
                    price:'',
                    customerCompany:'',
                }],
                links:[{
                  link:'',
                  grabBill:'',
                }],
                otherItems:[{
                    other:'',
                    money:''
                }],
                type:2
            }
        },
      switchCurve(index){
        this.switchBtnTab = index
        this.title = this.titleArr[index]
      },
      switchNewCurve(index){
        this.switchNewTab = index
        this.title = this.titleArr[index]
      },
        updateDetail(row){
            this.isDsi = true;
            this.newDialog = true;
            this.cWindow = false;
            this.pWindow = true;
            console.log(row)
            this.add=row
            var custMonth = row.year + "-" + row.month
            this.$set(this.add, "id", row.id);
            this.$set(this.add, "custMonth", custMonth);
            this.loudouList = '';
            this.getValueUpdate();
        },
        selectPageAll(){
            ss.netApi.selectPageNoSignCustom(this.q).then(res => {
                console.log(res.records)
                this.tableData = res.records
                this.q.total = res.total
            })
        },
        showFormList(value) {
            ss.netApi.selectUserName(value).then(res => {
                console.log(res)
                this.optionList = res.msg
                this.add.usercode = res.msg[0].userCode
                this.add.area = res.msg[0].area
                this.add.city = res.msg[0].city
            })
        },
        showFindByNameList (value) {
          console.log(value)
          ss.netApi.findByNameList(value).then(res => {
            console.log("res",res)
            this.findByNameList = res
          })
        },
        showplanList(){
            ss.netApi.selectTargetPlanList().then(res => {
                console.log(res)
                this.planList = res.msg
            })
        },
        shouLoudou(value){
            console.log(this.add.usercode)
            var data ={
                agentCode:this.add.usercode,
                projectName:value
            }
            // ss.netApi.selectLoudCucodeList(data).then(res => {
            //     console.log(res)
            //     this.loudouList = res.msg
            // })
        },
        changeLoudou(value,index){
          console.log(value,index)
          this.add.loudItems[index].projectname= value.projectName + "-" + value.proModel
          this.add.loudItems[index].funnelCode= value.funnelCode
          this.add.loudItems[index].brandPrice= value.totalPrice
        },
        showRebateSeries(){
            ss.netApi.selectRebateSeriesList().then(res => {
                console.log(res)
                this.rebateSeriesList = res.msg
            })
        },
        showTemplateReachTarget(){
            ss.netApi.selectTemplateTargetList().then(res => {
                console.log(res)
                this.templateReachTargetList = res.msg
            })
        },
        deleteSelete(){
            var data = this.multipleSelection.map(item => item.id).join()
            console.log(data)
            this.deleteSingle(data)
        },
        deleteSingle(id){
            var data ={
                ids:id,
                type:1
            }
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    ss.netApi.deleteCustom(data).then(res => {
                        console.log(res)
                        if(res.f == true ){
                             this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.selectPageAll()
                        }else{
                            this.$message.error(res.msg);
                        }
                    })

                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //
        uploaddownexcelflagbtn() {
            this.uploaddownexcelflag = true;
        },
        //导出
		exportExcel() {
            ///api/swyl/v1/monthly/order/common/downloadExcel
            updownfile.down("/api/swyl/v1/monthly/order/common/downloadExcel",this.q,"post",'data');
        },
        //表格
        handleSelectionChange(val) {
           this.multipleSelection = val;
        },
        getNowTime() {
            var now = new Date();
            var year = now.getFullYear(); //得到年份
            var month = now.getMonth(); //得到月份
            var date = now.getDate(); //得到日期
            month = month + 1;
            month = month.toString().padStart(2, "0");
            date = date.toString().padStart(2, "0");
            var defaultDate = `${year}-${month}-${date}`;
           // this.$set(this.q, "visitDate", defaultDate);
           // this.$set(this.add, "visitDateNew", defaultDate);
        },
        formatDate(row, column) {
          // 获取单元格数据
          let data = row[column.property]
          if(data == null || data == '') {
            return null
          }
          let dt = new Date(data)
          return this.$util.riQi3(dt);
        },
        // 展开折叠
        collapseChange(){
            this.isScreen = !this.isScreen;
        },
        rest(){
            var pageSize=this.q.pageSize;
            var pageNo=this.q.pageNo;
            var total=this.q.total;
            this.q= {
                pageSize: pageSize,
                pageNo: pageNo,
                total:total,
                type:2
            }
        },
        exit(){
            this.newDialog= false,
            this.editDialog = false
        },
        exitColse(){
            console.log("sfdsd")
            this.detailedDialog = false
        },
        getQuyuList(){
          ss.Dictservice.listbycategory("show_area").then(rd=>{
            this.quyuList = rd;
          })
        },
        getQudaoList(){
          ss.Dictservice.listbycategory("sales_region").then(rd=>{
            this.qudaoList = rd;
          })
        },
        getLinkList(){
          ss.Dictservice.listbycategory("xsyb_lianqun").then(rd=>{
            this.linkList = rd;
          })
        },
        getValue(){
          this.add.loudItems.forEach((item, index) => {
            this.add.loudItems[index].projectname = ''
            this.add.loudItems[index].brandPrice = ''
            this.add.loudItems[index].funnelCode = ''
          })
          var chanel = this.add.chanel
          var lianqun = this.add.links[0].link
          var usercode = this.add.usercode
          var data  = {
            "lianqun":lianqun,
            "customerChannel":chanel,
            "agentCode":usercode
          }
          if(null != chanel && null != lianqun && null != usercode &&
              "" != chanel && "" != lianqun && "" != usercode
          ){
            ss.netApi.selectLoudProject(data).then(res => {
              console.log(res)
              this.loudouList = res.msg
            })
          }
        },
        getValueUpdate(){
          var chanel = this.add.chanel
          var lianqun = this.add.links[0].link
          var usercode = this.add.usercode
          console.log("usercode",usercode)
          var data  = {
            "lianqun":lianqun,
            "customerChannel":chanel,
            "agentCode":usercode
          }
          if(null != chanel && null != lianqun && null != usercode &&
              "" != chanel && "" != lianqun && "" != usercode
          ){
            ss.netApi.selectLoudProject(data).then(res => {
              console.log(res)
              this.loudouList = res.msg
            })
          }
        },
    },

    created(){
        this.selectPageAll()
        this.showplanList()
        this.showRebateSeries()
        this.showTemplateReachTarget()
        this.getQudaoList()
        this.getLinkList()
        this.getQuyuList()
        for(var i =2021;i<new Date() .getFullYear()+2;i++){
          this.qyearList.push(i);
        }
    },
    components: {
        uploaddownexcel,
    },
}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:105px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    .addPro{
        width: 100%;
        /* display:flex; */
    }
    .addPro .el-form-item {
        width: 45% !important;
    }
    .addPro .el-form-item /deep/ .el-form-item__content{
        width:115px ;
    }
    /* 切换 */
    .card-namber{
        border-bottom: #dbdbdb 2px solid;
    }
    .card-namber span{
        padding: 0 10px ;
    }
    .buttonActive{
        color:#1b78e6;
        border-bottom:#1b78e6 2px solid;
        font-size: 14px;
        font-weight: 600
    }


    .loudItems-title{
        width: 100%;
    }
    .loudItems-title span{
        width: 33%;
        display: inline-block;
         padding:10px 0;
    }
    .templateItems-title span{
        width: 25%;
        display: inline-block;
         padding:10px 0;
    }
    .loudItems{
        width: 100%;
        margin: 0 auto
    }
    .loudItems .content{
        display:flex;
         padding:0 0 5px 0;
        /* justify-content:space-between;
        align-items:center */
    }
    .projectCon{
      display: flex;
      padding: 5px 0;
      margin: 0 10px 5px 10px;
      color: #1b78e6;
    }
    .projectCon p{
        display: flex;
		justify-content: space-between;
        align-items:center;
        font-size: 14px;
        border-bottom:#1b78e6 1px dashed;
        padding: 5px 0;
        margin: 0 auto 10px auto;
        color: #1b78e6;
    }
</style>
